module.exports = __webpack_public_path__ + "assets/img/632300.3912ffbb.png";